import * as React from 'react';
function SvgPlusCircleSolid(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' {...props}>
      <path d='M16 3C8.832 3 3 8.832 3 16s5.832 13 13 13 13-5.832 13-13S23.168 3 16 3zm0 2c6.086 0 11 4.914 11 11s-4.914 11-11 11S5 22.086 5 16 9.914 5 16 5zm-1 5v5h-5v2h5v5h2v-5h5v-2h-5v-5z' />
    </svg>
  );
}
export default SvgPlusCircleSolid;
